import { useLayoutEffect, useEffect } from 'react'

import { config } from '@/constants/config'

export const useIsomorphicLayoutEffect = config.isSSR ? useEffect : useLayoutEffect
